/**
 * The line a library score carries on Arrange: what it is, whose it is, and where it came from.
 *
 * A score opened from the library is somebody's transcription, and the page that plays it
 * says so for as long as it is on the board, with the same links the library row had. It sits
 * on the chrome under the toolbar rather than on the desk, so it never covers the music.
 */

import { Link } from "react-router-dom";
import type { LibraryEntry } from "@app/shared-types";
import { editionLabel, placing, sourceLabel } from "../lib/library";

const LINK = "underline decoration-shell-seam underline-offset-2 hover:text-shell-lit";

export default function LibraryCredit({ entry }: { entry: LibraryEntry }): JSX.Element {
  const where = placing(entry);
  return (
    <p className="flex shrink-0 flex-wrap items-baseline gap-x-3 gap-y-1 border-b border-shell-edge bg-shell-bar px-2.5 py-1 text-[11px] text-shell-dim">
      <span className="text-shell-text">
        {entry.composer} — {entry.title}
        {where === null ? "" : `, ${where}`}
      </span>
      <span>{entry.attribution}</span>
      <a className={LINK} href={entry.licenceUrl} target="_blank" rel="noreferrer">
        {entry.licence}
      </a>
      <a className={LINK} href={entry.sourceUrl} target="_blank" rel="noreferrer">
        {sourceLabel(entry)}
      </a>
      {entry.editionUrl === null ? null : (
        <a className={LINK} href={entry.editionUrl} target="_blank" rel="noreferrer">
          {editionLabel(entry)}
        </a>
      )}
      <Link className={LINK} to="/library">
        Library
      </Link>
    </p>
  );
}
